import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=05d97a8d&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=05d97a8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d97a8d",
  null
  
)

export default component.exports